<template>
  <f7-page id="reg-activate-biometry" name="reg-activate-biometry" @page:afterin="afterin">
    <div class="block">
      <div class="wandr-title-1 mb-xxl">{{$t('regis-active-biometry')}}</div>
      <p class="mt-md">{{$t('regis-active-biometry-text')}}</p>
    </div>
    <img class="biometry-icon" v-show="biometryType != 0" :src="require('@/assets/img/icon/icon-' + (biometryType == 1 ? 'fingerprint' : 'face_id') + '.svg')" style="" />

    <div class="footer block">
      <!-- <p class="text-align-center" v-html="tncAgreement"></p> -->
      <f7-button large fill class="mb-md" @click="openBiometry" :disabled="!isNextButtonValid">
        <span v-html="titleText"></span>
      </f7-button>
      <f7-button large outline @click="goToHomePage">
        {{$t('general-text-skip')}}
      </f7-button>
    </div>
  </f7-page>
</template>

<style>
#reg-activate-biometry .wandr-title-1 {
  color: #252525;
}
#reg-activate-biometry img.biometry-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
#reg-activate-biometry p {
  color: var(--f7-color-gray);
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
}
#reg-activate-biometry .footer p {
  font-size: 12px;
  line-height: 15px;
}
#reg-activate-biometry .footer{
  position: absolute;
  bottom: 24px;
  left: 0;
  right: 0;
}
</style>

<script>
  import { mapActions } from "vuex";
  export default {
    mounted (){
      const typeOfBiometry = this.biometryType == 1 ? this.$t('general-text-finger-print-id') : (this.biometryType == 2 ? this.$t('general-text-face-id') : "")
      
      // this.tncAgreement = this.$t('regis-biometry-tnc', {biometrytype: typeOfBiometry})
      this.titleText = this.$t('regis-biometry-enable', {biometrytype: typeOfBiometry})
    },
    data() {
      return {
        isNextButtonValid     : true,
        // tncAgreement          : "",
        titleText             : "",
      };
    },
    props: {
      biometryType: Number
    },
    methods: {
      ...mapActions('customer', ['validateBiometric']),
      ...mapActions('token', ['getToken']),
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      goToHomePage() {
        this.showPreloader();
        this.$f7router.navigate("/home");
        this.hidePreloader();
      },
      openBiometry() {
        if((window.Android && this.biometryType == 1) || (window.webkit && this.biometryType != 0)) {
          this.isNextButtonValid = false;
          this.openDeviceBiometry();
          this.$root.$once('handleValidationBiometryStatus', (status) => {
            if(status) {
              this.navigateToSuccessPage();
            }
          });
          setTimeout(() => {
            this.isNextButtonValid = true;
          }, 2000)
        }
      },
      navigateToSuccessPage() {
        this.$f7router.navigate("/register-biometry-success", { props: { biometryType: this.biometryType }});
      },
    },
    components: {

    },
    computed: {

    },
  }
</script>